import { LG } from "./liquidGlass";

const darkButton = {
  background: LG.color.buttonDark,
  color: LG.color.buttonDarkText,
  borderRadius: LG.radius.pill,
  fontWeight: 700,
  fontSize: "0.8rem",
  letterSpacing: "0.06em",
  textTransform: "uppercase" as const,
  border: "none",
  px: 3,
  py: 1.25,
  height: "40px",
  transition: LG.transition,
  "&:hover": { background: "#000", opacity: 0.9 },
};

const lightButton = {
  background: LG.color.surface,
  backdropFilter: LG.blurLight,
  WebkitBackdropFilter: LG.blurLight,
  color: LG.color.text,
  borderRadius: LG.radius.pill,
  fontWeight: 600,
  fontSize: "0.8rem",
  letterSpacing: "0.04em",
  textTransform: "uppercase" as const,
  border: `1px solid ${LG.color.border}`,
  px: 3,
  py: 1.25,
  height: "40px",
  transition: LG.transition,
  "&:hover": { background: LG.color.surfaceHover },
};

export const BUTTON_STYLES = {
  base: darkButton,
  primary: darkButton,
  secondary: {
    color: LG.color.textSecondary,
    fontWeight: 400,
    fontSize: "0.78rem",
    textTransform: "none" as const,
    textDecoration: "underline",
    minWidth: "auto",
    p: 0,
    border: "none",
    background: "transparent",
    "&:hover": { color: LG.color.text, background: "transparent" },
  },
  icon: {
    borderRadius: "50%",
    background: LG.color.surface,
    color: LG.color.text,
    border: `1px solid ${LG.color.border}`,
    height: "40px",
    width: "40px",
    "&:hover": { background: LG.color.surfaceHover },
  },
  disabled: {
    cursor: "not-allowed",
    opacity: 0.5,
    "&:hover": { cursor: "not-allowed" },
  },
  grey: lightButton,
  text: {
    color: LG.color.textSecondary,
    fontWeight: 400,
    fontSize: "0.8rem",
    textTransform: "none" as const,
    minWidth: "auto",
    background: "transparent",
    "&:hover": { color: LG.color.text, background: "transparent" },
  },
  borderedText: {
    color: LG.color.textSecondary,
    fontWeight: 400,
    fontSize: "0.8rem",
    textTransform: "none" as const,
    minWidth: "auto",
    background: "transparent",
    borderBottom: `1px solid ${LG.color.divider}`,
    "&:hover": { color: LG.color.text, background: "transparent" },
  },
  invertedPrimary: darkButton,
  outlinedPrimary: lightButton,
  compact: {
    fontSize: "0.75rem",
    px: 2,
    py: 0.5,
    height: "32px",
  },
} as const;
